import { render } from "./UTablePagination.vue?vue&type=template&id=6accad38"
import script from "./UTablePagination.vue?vue&type=script&lang=js"
export * from "./UTablePagination.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__